// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CourseList-module--wrapper--rPafj","closed":"CourseList-module--closed--2yHhr"};